<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Vendor
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                type="number"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.location"
                outlined
                label="Location"
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.location"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.address"
                outlined
                rows="3"
                label="Address"
                prepend-inner-icon="mdi-home"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.city"
                outlined
                label="City"
                prepend-inner-icon="mdi-city"
                :error-messages="errors.city"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.state"
                outlined
                label="State"
                prepend-inner-icon="mdi-map"
                :error-messages="errors.state"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.pincode"
                outlined
                label="Pincode"
                type="number"
                prepend-inner-icon="mdi-mailbox"
                :error-messages="errors.pincode"
                :loading="isFetchingPincode"
                @input="onPincodeInput"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.country"
                outlined
                label="Country"
                prepend-inner-icon="mdi-earth"
                :error-messages="errors.country"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.remarks"
                outlined
                rows="4"
                label="Remarks"
                prepend-inner-icon="mdi-note-text"
                :error-messages="errors.remarks"
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Status: ${form.is_active ? 'Active' : 'Inactive'}`"
                color="success"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            <v-icon left>mdi-content-save</v-icon>
            Update Vendor
          </v-btn>
          <v-btn
            rounded
            color="error"
            class="ml-3"
            :loading="isDeleting"
            :disabled="isDeleting"
            @click="deleteVendor"
          >
            <v-icon left>mdi-delete</v-icon>
            Delete Vendor
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Success Dialog -->
    <v-dialog v-model="isUpdatedVendor" width="600">
      <v-card rounded="xxl">
        <v-container>
          <v-row align="center">
            <v-col sm="3" align="center">
              <v-icon large style="color: green; font-size: 90px; width: 200px !important">
                mdi-check-circle
              </v-icon>
            </v-col>
            <v-col sm="9" align="center">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h1 style="color: green">Success!</h1>
                    <br />
                    <h3>Vendor updated successfully.</h3>
                    <br />
                    <v-btn color="success" @click="isUpdatedVendor = false; $router.push('/vendors')">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="isDeleteDialog" width="600">
      <v-card rounded="xxl">
        <v-container>
          <v-row align="center">
            <v-col sm="3" align="center">
              <v-icon large style="color: orange; font-size: 90px; width: 200px !important">
                mdi-alert-circle
              </v-icon>
            </v-col>
            <v-col sm="9" align="center">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h1 style="color: orange">Warning!</h1>
                    <br />
                    <h3>Are you sure you want to delete this vendor?</h3>
                    <br />
                    <v-btn color="error" @click="confirmDelete">Yes, Delete</v-btn>
                    <v-btn color="primary" class="ml-3" @click="isDeleteDialog = false">Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "VendorEditPage",
  data() {
    return {
      form: {
        name: "",
        phone: "",
        location: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        remarks: "",
        is_active: true,
      },
      isLoading: false,
      isDeleting: false,
      isUpdatedVendor: false,
      isDeleteDialog: false,
      isFetchingPincode: false,
      old_json: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.isLoading = true;
        const response = await axios.get(`/vendors/${this.$route.params.id}`);
        this.form = { ...response.data.data };
        this.old_json = { ...response.data.data };
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error("Error fetching vendor data:", error);
        this.$toast.error("Failed to load vendor data.");
        this.$router.push("/vendors");
      }
    },
    async onPincodeInput(value) {
      const pincode = String(value).replace(/\D/g, '');
      if (pincode.length === 6) {
        this.isFetchingPincode = true;
        try {
          const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
          const data = await response.json();
          if (data && data[0] && data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length > 0) {
            const postOffice = data[0].PostOffice[0];
            this.form.state = postOffice.State || this.form.state;
            this.form.city = postOffice.District || this.form.city;
            this.form.country = postOffice.Country || this.form.country || 'India';
          }
        } catch (error) {
          console.error('Error fetching pincode details:', error);
        } finally {
          this.isFetchingPincode = false;
        }
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.$store.dispatch('errors/setErrors', {});
        await axios.put(`/vendors/${this.$route.params.id}`, this.form);
        this.isLoading = false;
        this.isUpdatedVendor = true;
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.data && error.response.data.errors) {
          this.$store.dispatch('errors/setErrors', error.response.data.errors);
        } else {
          console.error("Error updating vendor:", error);
          this.$toast.error("Failed to update vendor. Please try again.");
        }
      }
    },
    deleteVendor() {
      this.isDeleteDialog = true;
    },
    async confirmDelete() {
      try {
        this.isDeleting = true;
        this.isDeleteDialog = false;
        await axios.post(`/vendors/delete/${this.$route.params.id}`);
        this.isDeleting = false;
        this.$toast.success("Vendor deleted successfully.");
        this.$router.push("/vendors");
      } catch (error) {
        this.isDeleting = false;
        console.error("Error deleting vendor:", error);
        this.$toast.error("Failed to delete vendor. Please try again.");
      }
    },
  },
};
</script>
